
import api from './../helpers/api'

class SupplierService{

    get_suppliers(){
        return api.get(`/get_suppliers`);
    }

    get_supplier(id){
        return api.get(`/get_supplier/${id}`)
    }

    create_supplier(supplier){
        return api.post(`/add_supplier`, supplier);
    }

    edit_supplier(supplier){
        return api.post(`/edit_supplier/${supplier.id}`, supplier);
    }

    delete_supplier(id){
        return api.post(`/delete_supplier/${id}`);
    }

    get_supplier_profile(id){
        return api.get(`/supplier_profile/${id}`);
    }

    pay_purchase(purchaseId, data){
        return api.post(`/save_purchase_balance/${purchaseId}`, data);
    }

    get_purchase_payments(purchaseId){
        return api.post(`/view_payed_purchases/${purchaseId}`, {});
    }

    get_outstanding_suppliers(){
        return api.get(`/supplier_outstanding`);
    }

}

export default new SupplierService
